export const L10N = {
  ACTION_MORE_INFO: { id: 'common.action.more_info' },

  LABEL_CANCELLATION_POLICY: { id: 'common.label.cancellation_policy' },
  LABEL_GENERIC_NAME: { id: 'common.label.accommodation' },
  LABEL_OTHERS_TERMS: { id: 'common.label.others_terms' },
  LABEL_PAYMENT_TERMS: { id: 'common.label.payment_terms' },
  LABEL_PRIVACY_POLICY_DESCRIPTION: { id: 'core.label.privacy_policy_disclaimer' },
  LABEL_PRIVACY_POLICY: { id: 'common.label.privacy_policy' },
};
